"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _awardColors;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.Dot = exports.Award = exports.Awards = exports.AwardsContainer = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _types = require("./types");

var awardColors = (_awardColors = {}, _defineProperty(_awardColors, _types.AwardTypes.GrandPrix, '#ffc800'), _defineProperty(_awardColors, _types.AwardTypes.Gold, '#deb162'), _defineProperty(_awardColors, _types.AwardTypes.Bronze, '#d28273'), _defineProperty(_awardColors, _types.AwardTypes.Silver, '#d7d7dc'), _defineProperty(_awardColors, _types.AwardTypes.Shortlisted, '#ffffff'), _awardColors);

var AwardsContainer = _styled.default.div(function (_ref) {
  var explicit = _ref.explicit,
      space = _ref.theme.space;
  return {
    display: 'flex',
    alignItems: explicit ? 'start' : 'center',
    flexDirection: explicit ? 'column-reverse' : 'row',
    margin: "".concat(space.xsmall, " 0")
  };
});

exports.AwardsContainer = AwardsContainer;

var Awards = _styled.default.ul(function (_ref2) {
  var explicit = _ref2.explicit,
      space = _ref2.theme.space;
  return {
    display: 'flex',
    alignItems: explicit ? 'start' : 'center',
    flexDirection: explicit ? 'column' : 'row',
    margin: 0,
    marginRight: explicit ? 0 : space.xsmall,
    marginTop: explicit ? space.base : 0,
    padding: 0,
    listStyle: 'none'
  };
});

exports.Awards = Awards;

var Award = _styled.default.div(function (_ref3) {
  var explicit = _ref3.explicit,
      space = _ref3.theme.space;
  return {
    display: 'flex',
    alignItems: 'center',
    marginBottom: explicit ? space.small : 0
  };
});

exports.Award = Award;

var Dot = _styled.default.li(function (_ref4) {
  var award = _ref4.award,
      space = _ref4.theme.space;
  return {
    width: '14px',
    height: '14px',
    borderRadius: '14px',
    backgroundColor: awardColors[award],
    marginRight: space.small,
    border: "2px solid ".concat(award === _types.AwardTypes.Shortlisted ? awardColors[_types.AwardTypes.Silver] : 'transparent')
  };
});

exports.Dot = Dot;